<div
	class="search-client"
	[ngClass]="{
		'search-client-nomargins': noMargins,
		'search-client-modal': newStyle,
		error: hasError
	}"
>
	<p-autoComplete
		[suggestions]="searchResult"
		(completeMethod)="searchClient($event)"
		(onSelect)="filterSelected($event)"
		(onBlur)="onBlur($event)"
		[size]="30"
		[dropdown]="false"
		[minLength]="0"
		field="name"
		inputId="inpSearch"
		autoHighlight="true"
		dataKey="id"
		emptyMessage="{{ 'GENERAL.NORESULTS' | translate }}"
		autocomplete="none"
		delay="350"
		dropdownMode="current"
		placeholder="{{ 'PLACEHOLDERS.CLIENTSEARCH' | translate }}"
	>
		<ng-template let-item pTemplate="item">
			<span data-id="{{ item.id }}">{{ item.name }}</span>
		</ng-template>
	</p-autoComplete>
</div>
